import { render } from "./EnlargeIcon.vue?vue&type=template&id=039de8e6&scoped=true&bindings={}"
import script from "./EnlargeIcon.vue?vue&type=script&lang=ts"
export * from "./EnlargeIcon.vue?vue&type=script&lang=ts"

import "./EnlargeIcon.vue?vue&type=style&index=0&id=039de8e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-039de8e6"

export default script